  <template>
  <div class="control-section">
      <div class="h100vh-140">
        <ejs-grid ref='grid' :dataSource="data" height='calc(100% - 0px)' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='66' textAlign='Center'  minWidth='10px'></e-column>
            <e-column field='pui' :headerText='$t("Pui.pui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='pvi' :headerText='$t("Pui.pvi")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='oipStatus' :headerText='$t("Pui.oipStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oipStatusFormatter'></e-column>
            <e-column field='oipOverride' :headerText='$t("Pui.oipOverried")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oipOverriedFormatter'></e-column>
            <e-column field='oirStatus' :headerText='$t("Pui.oirStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oirStatusFormatter'></e-column>
            <e-column field='oirMode' :headerText='$t("Pui.oirMode")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oirModeFormatter'></e-column>
            <e-column field='oirTemporarySet' :headerText='$t("Pui.oirTemporarySet")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oirTemporarySetFormatter'></e-column>
            <e-column field='oirRestrictMode' :headerText='$t("Pui.oirRestrictMode")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='oirRestrictModeFormatter'></e-column>
            <e-column field='cfuStatus' :headerText='$t("Pui.cfuStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfuStatusFormatter'></e-column>
            <e-column field='cfuPui' :headerText='$t("Pui.cfuPui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cfbStatus' :headerText='$t("Pui.cfbStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfbStatusFormatter'></e-column>
            <e-column field='cfbPui' :headerText='$t("Pui.cfbPui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cfnrStatus' :headerText='$t("Pui.cfnrStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfnrStatusFormatter'></e-column>
            <e-column field='cfnrPui' :headerText='$t("Pui.cfnrPui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cfnrTime' :headerText='$t("Pui.cfnrTime")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cfnlStatus' :headerText='$t("Pui.cfnlStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfnlStatusFormatter'></e-column>
            <e-column field='cfnlPui' :headerText='$t("Pui.cfnlPui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cfnrcStatus' :headerText='$t("Pui.cfnrcStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfnrcStatusFormatter'></e-column>
            <e-column field='cfnrcPui' :headerText='$t("Pui.cfnrcPui")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px'></e-column>
            <e-column field='cwStatus' :headerText='$t("Pui.cwStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cfnlPuiFormatter'></e-column>
            <e-column field='cwNotify' :headerText='$t("Pui.cwNotify")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='cwNotifyFormatter'></e-column>
            <e-column field='holdStatus' :headerText='$t("Pui.holdStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='holdStatusFormatter'></e-column>
            <e-column field='ocbStatus' :headerText='$t("Pui.ocbStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='ocbStatusFormatter'></e-column>
            <e-column field='icbStatus' :headerText='$t("Pui.icbStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='icbStatusFormatter'></e-column>
            <e-column field='thirdPartyStatus' :headerText='$t("Pui.thirdPartyStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='thirdPartyStatusFormatter'></e-column>
            <e-column field='confStatus' :headerText='$t("Pui.confStatus")' width='10%' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10px' :formatter='confStatusFormatter'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='qryPui()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
      </div>
      <CustomDialog ref='addPuiPage' :element='dialog.element.eleAddPui' :styles='dialog.styles' :messages='dialog.messages.addPui'>
        <template v-slot:dialog-content>
          <AddPuiForm ref="addPui" ></AddPuiForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='addBatchPuiPage' :element='dialog.element.eleAddBatchPui' :styles='dialog.styles' :messages='dialog.messages.addBatchPui'>
        <template v-slot:dialog-content>
          <AddBatchPuiForm ref="addBatchPui" ></AddBatchPuiForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='modPuiPage' :element='dialog.element.eleModPui' :styles='dialog.styles' :messages='dialog.messages.modPui'>
        <template v-slot:dialog-content>
          <ModPuiForm ref="modPui" ></ModPuiForm>
        </template>
      </CustomDialog>
      <CustomDialog ref='puiListPage' :element='dialog.element.eleQryPui' :styles='dialog.styles'>
        <template v-slot:dialog-content>
          <PuiList ref='puiList'></PuiList>
        </template>
      </CustomDialog>
      <DialogConfirm ref='dialogConfirm' :title='$t("LteUser.inquiry")' :content='$t("LteUser.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
      <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
    </div></template>
<script>
import { Reorder, Resize } from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../../common/CustomDialog";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddPuiForm from "./dialog/AddPuiForm";
import AddBatchPuiForm from "./dialog/AddBatchPuiForm";
import ModPuiForm from "./dialog/ModPuiForm";
import PuiList from "./dialog/QryPuiDialog";
import ajaxUrl from "../../data/ajaxUrl";
import { EventBus } from "../../../../plugins/eventBus";

export default {
  name: "PuiTable",
  components: {
    CustomDialog,
    DialogConfirm,
    AddPuiForm,
    AddBatchPuiForm,
    ModPuiForm,
    PuiList,
    DialogList
  },
  data() {
    return {
      data: {},
      filterFlag: false,
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0
      },
      ne: {
        neid: "",
        netype: "",
        neversion: ""
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: "810px",
          height: "760px",
          visible: false,
          model: true
        },
        stylesDelRange: {
          width: "810px",
          height: "auto",
          visible: false,
          model: true
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddPui: {
            target: this.$refs.addPui,
            refName: "eleAddPui",
            buttonGroup: [
              {
                click: this.saveAddPui,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeAddPuiPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pui.addPui"),
            isClose: true
          },
          eleAddBatchPui: {
            target: this.$refs.addBatchPui,
            refName: "eleAddBatchPui",
            buttonGroup: [
              {
                click: this.saveAddBatchPui,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeAddBatchPuiPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pui.addBatchPui"),
            isClose: true
          },
          eleModPui: {
            target: this.$refs.modPui,
            refName: "eleModPui",
            buttonGroup: [
              {
                click: this.saveModPui,
                buttonModel: {
                  content: this.$t("LteUser.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.closeModPuiPage,
                buttonModel: { content: this.$t("LteUser.cancel") }
              }
            ],
            title: this.$t("Pui.modPui"),
            isClose: true
          },
          eleQryPui: {
            target: this.$refs.puiList,
            refName: "eleQryPui",
            buttonGroup: [
              {
                click: this.closeQryPuiList,
                buttonModel: { content: this.$t("MCS.cancle") }
              }
            ],
            title: this.$t("Pui.puiList"),
            isClose: true
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: "dialogList",
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("LteUser.confirm") }
              }
            ],
            title: this.$t("LteUser.logger"),
            isClose: true
          }
        },
        messages: {
          addPui: {
            title: this.$t("Pui.addPui")
          },
          addBatchPui: {
            title: this.$t("Pui.addBatchPui")
          },
          modPui: {
            title: this.$t("Pui.modPui")
          }
        }
      },
      position: { X: "Center", Y: "Top" },
      imsiFilter: "",
      descCommonError: {
        0: this.$t("DNN.commonError0"),
        1: this.$t("DNN.commonError1"),
        2: this.$t("DNN.commonError2"),
        3: this.$t("DNN.commonError3"),
        4: this.$t("DNN.commonError4"),
        5: this.$t("DNN.commonError5"),
        6: this.$t("DNN.commonError6"),
        7: this.$t("DNN.commonError7"),
        8: this.$t("DNN.commonError8"),
        9: this.$t("DNN.commonError9"),
        10: this.$t("DNN.commonError10"),
        11: this.$t("DNN.commonError11"),
        12: this.$t("DNN.commonError12"),
        13: this.$t("DNN.commonError13"),
        14: this.$t("DNN.commonError14"),
        15: this.$t("DNN.commonError15")
      },
      authType: {
        0: this.$t("Pui.authType0"),
        1: this.$t("Pui.authType1"),
        2: this.$t("Pui.authType2")
      },
      modeType: {
        0: this.$t("Pui.modeType0"),
        1: this.$t("Pui.modeType1")
      },
      showType: {
        0: this.$t("Pui.showType0"),
        1: this.$t("Pui.showType1")
      },
      forbidType: {
        0: this.$t("Pui.forbidType0"),
        1: this.$t("Pui.forbidType1")
      },
      cwNotifyType: {
        0: this.$t("Pui.cwNotifyType0"),
        1: this.$t("Pui.cwNotifyType1")
      }
    };
  },
  provide: {
    grid: [Reorder, Resize]
  },
  methods: {
    oipStatusFormatter(grids, data) {
      return this.authType[data.oipStatus];
    },
    oipOverriedFormatter(grids, data) {
      return this.authType[data.oipOverride];
    },
    oirStatusFormatter(grids, data) {
      return this.authType[data.oirStatus];
    },
    oirModeFormatter(grids, data) {
      return this.modeType[data.oirMode];
    },
    oirTemporarySetFormatter(grids, data) {
      return this.showType[data.oirTemporarySet];
    },
    oirRestrictModeFormatter(grids, data) {
      return this.forbidType[data.oirRestrictMode];
    },
    cfuStatusFormatter(grids, data) {
      return this.authType[data.cfuStatus];
    },
    cfbStatusFormatter(grids, data) {
      return this.authType[data.cfbStatus];
    },
    cfnrStatusFormatter(grids, data) {
      return this.authType[data.cfnrStatus];
    },
    cfnlStatusFormatter(grids, data) {
      return this.authType[data.cfnlStatus];
    },
    cfnrcStatusFormatter(grids, data) {
      return this.authType[data.cfnrcStatus];
    },
    cfnlPuiFormatter(grids, data) {
      return this.authType[data.cwStatus];
    },
    cwNotifyFormatter(grids, data) {
      return this.cwNotifyType[data.cwNotify];
    },
    holdStatusFormatter(grids, data) {
      return this.authType[data.holdStatus];
    },
    ocbStatusFormatter(grids, data) {
      return this.authType[data.ocbStatus];
    },
    icbStatusFormatter(grids, data) {
      return this.authType[data.icbStatus];
    },
    thirdPartyStatusFormatter(grids, data) {
      return this.authType[data.thirdPartyStatus];
    },
    confStatusFormatter(grids, data) {
      return this.authType[data.confStatus];
    },
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryPui();
    },
    isChooseNe() {
      if (this.ne.neid === "") {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("LteUser.pleaseSelectNE")
        });
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("PDN.pleaseSelectDatas")
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("PDN.pleaseSelectOneData")
        });
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const userId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        userId.push(checkedData[i].pui);
      }
      return userId.length === 0 ? false : userId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
      if (0 !== response.data.resultVal.result) {
        EventBus.$emit("toast", {
          type: "warning",
          // content: this.$t("DNN.commonError" + response.data.resultVal.result)
          content: response.data.errorString

        });
        return true;
      }
      return false;
    },
    openAddPuiPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addPui.getJson(this.ne, response => {
        if (response.data.errorCode !== "0") {
          EventBus.$emit("toast", {
            type: "warning",
            content: response.data.errorString
          });
          return;
        }
        this.$refs.addPuiPage.show();
      });
    },
    closeAddPuiPage() {
      this.$refs.addPuiPage.clear();
      this.$refs.addPuiPage.close();
    },
    saveAddPui() {
      this.$refs.addPui.saveUser(this.ne, response => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddPuiPage();
        EventBus.$emit("toast", {
          type: "success",
          content: this.$t("Pui.addPuiSuccess")
        });
        this.qryPui();
      });
    },
    getKey(obj, value) {
      for (let key in obj) {
        if (value === obj[key]) {
          return Number(key);
        }
      }
    },
    openModPuiPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
        const record = checkedDatas.map(item => {
          return {
            ...item
          };
        });
        this.$refs.modPui.getJson(this.ne, record, response => {
          if (response.data.errorCode !== "0") {
            EventBus.$emit("toast", {
              type: "warning",
              content: response.data.errorString
            });
            return;
          }
          this.$refs.modPuiPage.show();
        });
      }
    },
    closeModPuiPage() {
      this.$refs.modPuiPage.clear();
      this.$refs.modPuiPage.close();
    },
    saveModPui() {
      this.$refs.modPui.saveUser(this.ne, response => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModPuiPage();
        EventBus.$emit("toast", {
          type: "success",
          content: this.$t("Pui.modPuiSuccess")
        });
        this.qryPui();
      });
    },

    /**
     * 打开/关闭/保存  pui列表页面
     */
    openQryPviByPuiPage() {
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas.length !== 0) {
        const record = checkedDatas.map(item => {
          return {
            ...item
          };
        });
        this.$refs.puiList.getPuiListByPui(record, this.ne.neid);
        this.$refs.puiListPage.show();
      }
    },
    closeQryPuiList() {
      this.$refs.puiListPage.clear();
      this.$refs.puiListPage.close();
    },
    delUsers() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      const params = {
        vo: {
          puiList: delKeys
        },
        info: {
          msgid: "30485",
          neid: this.ne.neid
        }
      };

      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("onClickDelOk response error");
          return;
        }
        if (!response.data) {
          console.log("onClickDelOk response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("onClickDelOk response.data.resultVal null error");
          return;
        }
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultCodeStr[i],
            operCode: resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        this.qryPui(undefined, undefined, true);
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    refreshData() {
      this.imsiFilter = "";
      this.filterFlag = false;
      this.qryPui(0, true);
    },
    filterData() {
      this.filterFlag = true;
      this.qryPui(1, true);
    },
    qryPui(flag = undefined, prompt = false, delFlag = false) {
      if (this.isChooseNe() === false) {
        return;
      }
      this.page.pageNo = this.filterFlag
        ? 1
        : this.$refs.pager.ej2Instances.currentPage;
      if (delFlag) {
        this.page.pageNo = 1;
      }
      this.filterFlag = false;

      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      let params = {
        vo: {
          flag: 0
        },
        info: {
          msgid: "30486",
          neid: this.ne.neid
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize
        }
      };

      if (flag === 1) {
        //1是单独查询
        if (this.imsiFilter == "") {
          //查询的是空则相当于刷新
          this.refreshData();
        } else {
          params = {
            vo: {
              pui: this.imsiFilter
            },
            info: {
              msgid: "30483",
              neid: this.ne.neid
            },
            page: {
              pageNo: this.page.pageNo,
              pageSize: this.page.pageSize
            }
          };
        }
      }

      this.$axios.post(ajaxUrl.requestCommonD, params).then(response => {
        //真数据
        console.log("qryPui response", response);
        if (!response) {
          console.log("qryPui response error");
          return;
        }
        if (!response.data) {
          console.log("qryPui response.data error");
          return;
        }
        if (response.data.errorCode === "subscriber.9005") {
          this.ne.neid = "";
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit("toast", {
            type: "warning",
            content: this.$t("MCS.neOffLine")
          });
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryPui response.data.resultVal error");
          return;
        }
        if (
          response.data.resultVal.result !== 0 &&
          response.data.resultVal.result !== 1
        ) {
          console.log("qryPui response.data.resultVal.result error");
          return;
        }
        const res = response.data.resultVal; //todo 假数据
        if (res) {
          if (res.puiInfo) {
            const puiInfo = res.puiInfo.map(item => {
              return {
                ...item
              };
            });
            this.data = puiInfo;
          } else {
            this.data = [];
          }
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
      });
    },
    openAddBatchPuiPage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addBatchPui.getJson(this.ne, response => {
        if (response.data.errorCode !== "0") {
          EventBus.$emit("toast", {
            type: "warning",
            content: response.data.errorString
          });
          return;
        }
        this.$refs.addBatchPuiPage.show();
      });
    },
    closeAddBatchPuiPage() {
      this.$refs.addBatchPuiPage.clear();
      this.$refs.addBatchPuiPage.close();
    },
    saveAddBatchPui() {
      this.$loading.showLoadding(
        this.$t("Pui.addBatchPui"),
        this.$t("SubscriberIms.waitTip")
      );
      this.$refs.addBatchPui.saveBatchUser(this.ne, (response, addPviList) => {
        if (this.responseIsFailed(response)) {
          this.$loading.hideLoadding();
          return;
        }
        this.closeAddBatchPuiPage();
        this.$loading.hideLoadding();
        const resultVal = response.data.resultVal.resultCode;
        const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < addPviList.length; i++) {
          operList.push({
            operObj: addPviList[i].pui,
            operResult: resultCodeStr[i],
            operCode: resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(addPviList.length);
        this.$refs.dialogListPage.show();
        this.qryPui();
      });
    },
    setfilter(params) {
      this.imsiFilter = params;
    }
  }
};
</script>

<style scoped>
</style>
